import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";

export const adminLinearCleanupIssuesQueryKey = (orgId: string) =>
  ["admin", "org", orgId, "linear-cleanup-issues"] as const;

export function useAdminLinearCleanupIssues(orgId: string) {
  return useQuery({
    queryKey: adminLinearCleanupIssuesQueryKey(orgId),
    queryFn: () =>
      api
        .get<"/admin/:orgId/linear-cleanup-issues">(
          `/admin/${orgId}/linear-cleanup-issues`,
        )
        .then((res) => res.data),
    refetchInterval: (query) =>
      query.state.data?.some((issue) => issue.status === "creating")
        ? 3000
        : false,
  });
}

export function useAdminLinearCleanupIssue(orgId: string, issueId: string) {
  return useQuery({
    queryKey: [...adminLinearCleanupIssuesQueryKey(orgId), issueId],
    queryFn: () =>
      api
        .get<"/admin/:orgId/linear-cleanup-issues/:issueId">(
          `/admin/${orgId}/linear-cleanup-issues/${issueId}`,
        )
        .then((res) => res.data),
    refetchInterval: (query) =>
      query.state.data?.status === "creating" ? 3000 : false,
  });
}
